import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getReservationForm = get('reservation.components.form');

export const getDefaultEvent = createSelector(
  getReservationForm,
  get('defaultEvent')
);

export const getIsFetchingEvent = createSelector(
  getReservationForm,
  get('fetchingEvent')
);

export const getIsFetchedEvent = createSelector(
  getReservationForm,
  get('fetchedEvent')
);

export const getFetchEventError = createSelector(
  getReservationForm,
  get('fetchEventError')
);
